import { CHAT, websocketapp, setEmergencyHelpResponse, setIsHelpedResponse } from '@/common/websocket/index'
import { MessageBox } from 'element-ui'
import { emergencyHelpLog, getEmergencyHelpLog } from '@/api/log/operation'
import { warning, getSession } from '@/api/common'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '@/store/index'
import router from '@/router/index'
import { hasPermission } from '@/util/common'
import i18n from '@/common/i18n'

setEmergencyHelpResponse(emergencyHelp)
setIsHelpedResponse(isHelped)
let EmergencyHelmetLeave = function() {}
/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setEmergencyHelmetLeave(callback) {
  EmergencyHelmetLeave = callback
}
let waikeLeave = function() {}
/**
 * 外部设置 关闭语音通话逻辑
 * @param {Function} callback 关闭语音通话逻辑
 */
function setWaikeLeave(callback) {
  waikeLeave = callback
}
/**
 * 接收一键求助信息
 * @param datas
 * @param params
 */
function emergencyHelp(datas, params) {
  console.log('emergencyHelp', datas, params, hasPermission)
  // 当不具备精准调度权限和实时监控权限时，不弹出一键求助提示框
  if (!hasPermission('sys:new:command') && !hasPermission('monitor:manage')) {
    return
  }
  let status = JSON.parse(params.status)
  setTimeout(() => {
    let audio = document.getElementById('playAudio')
    audio.play()
  }, 100)
  if (getSession('access_token')) {
    //判断登录用户是否有权限接收一键求助（求助人的机构为登录用户的本下级机构时为有权限）
    MessageBox.confirm(
      `<div class="helpAlert">
        <div class="helpTitle">
          <i class="helpIcon"></i>
          <span>${i18n.t('helpMessage')}</span>
        </div>
        <div class="content">
          <span>${status.fullName}-${params.helmetId}${i18n.t('requestAssistance')}</span>
        </div>
      </div>`,
      {
        confirmButtonText: i18n.t('accept'),
        cancelButtonText:  i18n.t('ignore'),
        dangerouslyUseHTMLString: true,
      }
    )
      .then(() => {
        if (store.state.openWaike === true) {
          MessageBox.confirm(
            `<div class="helpAlert">
            <div class="content">
              <p>${i18n.t('disconnectVoice')}</p>
            </div>
          </div>`,
            {
              confirmButtonText: i18n.t('accept'),
              cancelButtonText:  i18n.t('ignore'),
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              store.commit('openWaike', false)
              waikeLeave()
              // 正在实时视频时关闭实时视频
              EmergencyHelmetLeave()
              CHAT.doActionType = 1
              CHAT.chat(websocketapp.ISHELPED, params.helmetId, JSON.parse(datas.msg))
            })
            .catch(() => {
              CHAT.doActionType = -1
            })
        } else {
        // 正在实时视频时关闭实时视频
        EmergencyHelmetLeave()
        CHAT.doActionType = 1
        CHAT.chat(websocketapp.ISHELPED, params.helmetId, JSON.parse(datas.msg))
        store.commit('openVedio', true)
        store.commit('voiceShow', false)
        // 关闭对讲
        store.commit('walkieShow', false)
        store.commit('setHelpVideo',true)
        // this.$store.commit('handleIsTrtcMuted', false)
        }
      })
      .catch(() => {
        CHAT.doActionType = -1
      })
    zconfirm(params)
  }
}

//记录发起“一键求助”日志,操作状态为0
function zconfirm(params) {
  console.log(params)
  console.log(JSON.parse(params.status).userId)
  let param = [
    {
      loginUserName: getSession('loginUserName'),
      sendTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
      status: 0,
      remoteUserName: JSON.parse(params.status).fullName,
      remoteHelmetId: params.helmetId,
      remoteUserId: JSON.parse(params.status).userId + '',
    },
  ]
  emergencyHelpLog(param).then(res => {
    console.log(res)
    if (res.state === 0) {
      CHAT.helpId = res.value[0].id
    }
  })
}

/**
 * 接收是否已求助信息（一键求助页面跳转与逻辑处理）
 * @param datas
 * @param params
 */
function isHelped(datas, params) {
  console.log('I am isHelped', datas, params)
  if (params.isHelped === 'true') {
    warning(i18n.t('helpBeenHandled'))
    return
  }
  // 如果没被处理，则判断安全帽是否在线
  if (params.clientState === 'false') {
    warning(i18n.t('abnormalConnectionSafetyHelmet'))
    return
  }
  // 告诉安全帽端此客户端接受求助
  CHAT.chat(websocketapp.EMERGHELP, params.helmetId, JSON.parse(datas.msg))
  let status = JSON.parse(params.status)
  let helpInfo = {
    serialNumber: params.helmetId,
    username: status.fullName,
    userId: status.userId,
  }
  store.commit('changeHelpInfo', helpInfo)
  // 修改求助状态
  store.commit('handleIsEmergency', true)
  // 跳转到监控页面，然后通过对应页面通过 watch helpInfo 进行实时视频/视频监控
  if (window.location.href.indexOf('newIndex') !== -1) {
    router.push({ path: '/newIndex/newCommand' })
    store.commit('currentIndex', 'command')
    store.commit('updatePlayTrail', false)
  }
  if (CHAT.doActionType === 1) {
    updateHelpLog('1')
  } else if (CHAT.doActionType === 0) {
    updateHelpLog('2')
  } else if (CHAT.doActionType === -1) {
    updateHelpLog('3')
  }
}
/**
 * 更新求助日志
 * @param {*} receiveHelpType 求助类型
 * @returns
 */
function updateHelpLog(receiveHelpType) {
  var helpId = CHAT.helpId
  receiveHelpType = parseInt(receiveHelpType)
  if (isNaN(helpId)) {
    warning('求助日志id非法，同步“一键求助”日志失败！')
    errorCollection('一键求助', '更新求助日志', {
      status: 200,
      data: { state: -1, msg: '求助日志id非法，同步“一键求助”日志失败！' },
    })
    return
  }
  if (isNaN(receiveHelpType)) {
    warning('求助处理类型出错，同步“一键求助”日志失败！')
    errorCollection('一键求助', '更新求助日志', {
      status: 200,
      data: { state: -1, msg: '求助处理类型出错，同步“一键求助”日志失败！' },
    })
    return
  }
  getEmergencyHelpLog(helpId).then(res => {
    if (res.state === 0) {
      let param = [
        {
          id: res.value.id,
          loginUserName: getSession('loginUserName'),
          sendTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
          status: CHAT.doActionType,
          remoteUserName: res.value.remoteUserName,
          remoteHelmetId: res.value.remoteHelmetId,
          remoteUserId: res.value.remoteUserId,
          handleTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
        },
      ]
      emergencyHelpLog(param).then(res => {
        console.log('一键求助日志同步成功！')
      })
    }
  })
}

export { setEmergencyHelmetLeave,setWaikeLeave }
